/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  ShareboxCaseKeyStatusModel,
  ShareboxGetCaseKeyStatusParams,
  ShareboxHubOverviewModel,
  ShareboxLocationOptionModel,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useShareboxGetCaseKeyStatusHook = () => {
  const shareboxGetCaseKeyStatus =
    useCustomInstance<ShareboxCaseKeyStatusModel[]>();

  return useCallback(
    (params?: ShareboxGetCaseKeyStatusParams, signal?: AbortSignal) => {
      return shareboxGetCaseKeyStatus({
        url: `/api/Sharebox/GetCaseKeyStatus`,
        method: 'GET',
        params,
        signal,
      });
    },
    [shareboxGetCaseKeyStatus]
  );
};

export const getShareboxGetCaseKeyStatusQueryKey = (
  params?: ShareboxGetCaseKeyStatusParams
) => {
  return [
    `/api/Sharebox/GetCaseKeyStatus`,
    ...(params ? [params] : []),
  ] as const;
};

export const useShareboxGetCaseKeyStatusQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>
  >,
  TError = unknown,
>(
  params?: ShareboxGetCaseKeyStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getShareboxGetCaseKeyStatusQueryKey(params);

  const shareboxGetCaseKeyStatus = useShareboxGetCaseKeyStatusHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>>
  > = ({ signal }) => shareboxGetCaseKeyStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ShareboxGetCaseKeyStatusQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>>
>;
export type ShareboxGetCaseKeyStatusQueryError = unknown;

export const useShareboxGetCaseKeyStatus = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>
  >,
  TError = unknown,
>(
  params?: ShareboxGetCaseKeyStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useShareboxGetCaseKeyStatusHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useShareboxGetCaseKeyStatusQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useShareboxGetLocationsHook = () => {
  const shareboxGetLocations =
    useCustomInstance<ShareboxLocationOptionModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return shareboxGetLocations({
        url: `/api/Sharebox/GetLocations`,
        method: 'GET',
        signal,
      });
    },
    [shareboxGetLocations]
  );
};

export const getShareboxGetLocationsQueryKey = () => {
  return [`/api/Sharebox/GetLocations`] as const;
};

export const useShareboxGetLocationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getShareboxGetLocationsQueryKey();

  const shareboxGetLocations = useShareboxGetLocationsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>
  > = ({ signal }) => shareboxGetLocations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ShareboxGetLocationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>
>;
export type ShareboxGetLocationsQueryError = unknown;

export const useShareboxGetLocations = <
  TData = Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetLocationsHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useShareboxGetLocationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useShareboxGetHubOverviewHook = () => {
  const shareboxGetHubOverview =
    useCustomInstance<ShareboxHubOverviewModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return shareboxGetHubOverview({
        url: `/api/Sharebox/GetHubOverview`,
        method: 'GET',
        signal,
      });
    },
    [shareboxGetHubOverview]
  );
};

export const getShareboxGetHubOverviewQueryKey = () => {
  return [`/api/Sharebox/GetHubOverview`] as const;
};

export const useShareboxGetHubOverviewQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getShareboxGetHubOverviewQueryKey();

  const shareboxGetHubOverview = useShareboxGetHubOverviewHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>
  > = ({ signal }) => shareboxGetHubOverview(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ShareboxGetHubOverviewQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>
>;
export type ShareboxGetHubOverviewQueryError = unknown;

export const useShareboxGetHubOverview = <
  TData = Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShareboxGetHubOverviewHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useShareboxGetHubOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
